'use strict';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/skip';
import {buildInjector} from '../../_libs/angular-utils';
import {ReduxList, SyncStatus} from '../../_libs/redux-observable-list';
import {sortByPropertyAccessor} from '../../core-utilities/filters/filterUtils';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {SYNC_MODEL_PATH, SYNC_PATH} from '../../core-utilities/rx-utils';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {buildUserChannelSyncNotifier} from '../../auth/utils/redux-lists';
import {updatePosition} from '../../settings/actions';
import {ACTIVE_TIMERS_COLLECTION} from '../domain/config';
import {pauseTimer, startTimer, stopTimer} from '../actions';
import {getActiveTimers} from '../reducers/state';
import {syncModel} from '../utils';
import {ACTIVE_TIMERS_LIST_PREFIX} from './state';
import {logger} from './logger';

/*
 * timers create method:
 *
 * request an active timer existence check in the same interval as the current active timer
 *   find existing by:
 *     it.target
 *     it.user
 *     it.loc[0].start
 *     it.isStopped ? it.loc[-1].end : Date.now()
 *
 * If there is an existing timer, assume the id of the existing instance and call the perform sync method
 *
 * Otherwise, create a new active timer instance in the DB and communicate back the appropriate data
 *
 */

/*
 * timers sync method:
 *
 * perform a union on the time intervals in a.intervals and b.intervals
 *
 * calculate the new totalTime value from the merged intervals array
 *
 * perform a union on the location captured data in a.loc and b.loc
 * - merge the arrays
 * - order all of the points by timestamp
 * - omit consecutive identical points starting from the oldest
 *
 * update locaCaptured to true if either value is true
 *
 * update isStopped to true if either value is true
 *
 */

// load angular dependencies:
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'FirebaseUtil',
]);

/** @type {ReduxList} */
export const reduxList = new ReduxList({
  ...BASE_REDUX_LIST_OPTIONS,
  prefix: ACTIVE_TIMERS_LIST_PREFIX,
  hasParentId: false,
  useSyncUpdates: true,
  canSyncCreate: true,
  getState: getActiveTimers,
  applySortOptions,
  listPath: ACTIVE_TIMERS_COLLECTION,
  listSyncPath: `${ACTIVE_TIMERS_COLLECTION}/${SYNC_PATH}`,
  syncModelPath: `${ACTIVE_TIMERS_COLLECTION}/${SYNC_MODEL_PATH}`,
  syncNotifier: buildUserChannelSyncNotifier('active-timers'),
  syncModel,
  logger,
  handleProcessingConflict,
  syncModelActionsTypes: [startTimer.TYPE, pauseTimer.TYPE, stopTimer.TYPE, updatePosition.TYPE],
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options, {
  listTransform: removeStopped,
  autoInit: false,
});

function applySortOptions(list) {
  return list.sort(sortByPropertyAccessor(getLastUpdatedDate, false, true));
}

function getLastUpdatedDate(item) {
  return item ? item.lastUpdated : void 0;
}

/** @type {ReduxObservableListOptions~handleProcessingConflict} */
function handleProcessingConflict(oldItem, newItem, options, state) {
  if (newItem === null) {
    return null;
  } else if (oldItem) {
    switch (oldItem.syncStatus) {
      case SyncStatus.PENDING:
      case SyncStatus.IN_PROGRESS:
      case SyncStatus.IN_PROGRESS_W_PENDING:
        // let the server sort it out with a sync attempt
        return oldItem;

      case SyncStatus.NONE:
      case SyncStatus.SUCCESS:
      default:
        // local state is not pending any updates, override with server value
        return newItem;
    }
  }
}

export function removeStopped(list) {
  return list.filter(item => !item.isStopped);
}



// WEBPACK FOOTER //
// ./src/js/timers/redux/activeTimers.js